import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const vectorSearch: ThemeApp['appComponents']['vectorSearch'] = {
  footerLinks: {
    color: themeUi.semantic.color.text.neutral600
  }
};
